// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.lm-admin-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .lm-admin-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .lm-admin-page {
    padding: 16px 16px 28px;
  }
}

.lm-admin-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
}
@media (max-width: 640px) {
  .lm-admin-header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
}
.lm-admin-header__left {
  flex: 1;
}
.lm-admin-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lm-admin-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .lm-admin-header__title {
    font-size: 22px;
  }
}
.lm-admin-header__count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(105, 190, 40), #569c21);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0.02em;
}
.lm-admin-header__count-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.lm-admin-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
}
.lm-admin-breadcrumb li {
  display: flex;
  align-items: center;
}
.lm-admin-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.lm-admin-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.lm-admin-breadcrumb li a:hover {
  color: rgb(105, 190, 40);
}
.lm-admin-breadcrumb li.lm-admin-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.lm-admin-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .lm-admin-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px 16px;
  }
}
.lm-admin-toolbar__left {
  flex: 1;
  max-width: 360px;
}
@media (max-width: 767px) {
  .lm-admin-toolbar__left {
    max-width: none;
  }
}
.lm-admin-toolbar__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
@media (max-width: 640px) {
  .lm-admin-toolbar__right {
    justify-content: flex-start;
  }
}

.lm-admin-search {
  position: relative;
  width: 100%;
}
.lm-admin-search__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 13px;
  pointer-events: none;
}
.lm-admin-search__input {
  width: 100%;
  padding: 9px 36px 9px 34px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
}
.lm-admin-search__input::placeholder {
  color: #ccc;
}
.lm-admin-search__input:focus {
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 3px rgba(105, 190, 40, 0.1);
}
.lm-admin-search__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #ccc;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  transition: background 0.15s ease;
}
.lm-admin-search__clear:hover {
  background: #676a6c;
}

.lm-admin-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
  line-height: 1.4;
}
.lm-admin-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.lm-admin-btn--primary:hover {
  background: #4cae4c;
  border-color: #4cae4c;
}
.lm-admin-btn--secondary {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.lm-admin-btn--secondary:hover {
  background: #f1f1f2;
  border-color: #ccc;
}

.lm-admin-content {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: visible;
  min-height: 200px;
}

.lm-admin-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.lm-admin-state > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.lm-admin-state p {
  font-size: 15px;
  color: #676a6c;
  margin: 0;
}
.lm-admin-state--loading {
  padding: 48px 20px;
}

.lm-admin-table-wrap {
  overflow-x: auto;
}

.lm-admin-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}
.lm-admin-table thead tr {
  background: #f1f1f2;
}
.lm-admin-table thead th {
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-align: left;
}
.lm-admin-table thead th i.fa {
  margin-left: 4px;
  font-size: 12px;
  color: #ccc;
}
.lm-admin-table tbody tr {
  transition: background-color 0.12s ease;
  border-bottom: 1px solid #e7eaec;
}
.lm-admin-table tbody tr:hover {
  background-color: rgba(105, 190, 40, 0.03);
}
.lm-admin-table tbody tr:nth-of-type(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
.lm-admin-table tbody tr:nth-of-type(even):hover {
  background-color: rgba(105, 190, 40, 0.03);
}
.lm-admin-table tbody tr td {
  padding: 12px 16px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
}
.lm-admin-table__link {
  color: #676a6c;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.15s ease;
}
.lm-admin-table__link:hover {
  color: rgb(105, 190, 40);
}
.lm-admin-table__features {
  margin-top: 4px;
}
.lm-admin-table__feature-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-radius: 3px;
  margin-right: 4px;
}
.lm-admin-table__feature-tag--staging {
  color: rgb(0, 173, 208);
  background: rgba(0, 173, 208, 0.1);
}
.lm-admin-table__feature-tag--prod {
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.1);
}
.lm-admin-table__sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.15s ease;
}
.lm-admin-table__sortable:hover {
  color: rgb(105, 190, 40);
}
.lm-admin-table__sortable:hover i.fa {
  color: rgb(105, 190, 40);
}
.lm-admin-table__actions-col {
  width: 140px;
  text-align: left;
}
.lm-admin-table__actions {
  white-space: nowrap;
  text-align: left;
  vertical-align: middle !important;
}
.lm-admin-table__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0 2px;
  border-radius: 5px;
  font-size: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.lm-admin-table__action--edit {
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  border-color: rgba(0, 173, 208, 0.15);
}
.lm-admin-table__action--edit:hover {
  background: rgb(0, 173, 208);
  color: #fff;
}
.lm-admin-table__action--clone {
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  border-color: rgba(105, 190, 40, 0.15);
}
.lm-admin-table__action--clone:hover {
  background: rgb(105, 190, 40);
  color: #fff;
}
.lm-admin-table__action--view {
  background: rgba(103, 106, 108, 0.06);
  color: #676a6c;
  border-color: rgba(103, 106, 108, 0.12);
}
.lm-admin-table__action--view:hover {
  background: #676a6c;
  color: #fff;
}
.lm-admin-table__action--delete {
  opacity: 0;
  pointer-events: none;
  background: rgba(245, 67, 89, 0.08);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.15);
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.lm-admin-table__action--delete:hover {
  background: rgb(245, 67, 89);
  color: #fff;
}
.lm-admin-table__action--save {
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  border-color: rgba(105, 190, 40, 0.15);
}
.lm-admin-table__action--save:hover {
  background: rgb(105, 190, 40);
  color: #fff;
}
.lm-admin-table__action--cancel {
  background: rgba(255, 121, 0, 0.08);
  color: rgb(255, 121, 0);
  border-color: rgba(255, 121, 0, 0.15);
}
.lm-admin-table__action--cancel:hover {
  background: rgb(255, 121, 0);
  color: #fff;
}

.lm-admin-table tbody tr:hover .lm-admin-table__action--delete {
  opacity: 1;
  pointer-events: auto;
}

.lm-admin-input {
  width: 100%;
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  transition: border-color 0.2s ease;
}
.lm-admin-input:focus {
  border-color: rgb(105, 190, 40);
  outline: none;
  box-shadow: 0 0 0 2px rgba(105, 190, 40, 0.1);
}
.lm-admin-input__error {
  display: block;
  font-size: 11px;
  color: rgb(245, 67, 89);
  margin-top: 3px;
  font-weight: 600;
}

.lm-admin-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #e7eaec;
}
.lm-admin-pagination__perpage {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lm-admin-pagination__perpage label {
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  margin: 0;
  white-space: nowrap;
}
.lm-admin-pagination__perpage select {
  width: 70px;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  color: #676a6c;
  background: #fff;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.lm-admin-pagination__perpage select:focus {
  border-color: rgb(105, 190, 40);
  outline: none;
}
.lm-admin-pagination__pages {
  display: flex;
  align-items: center;
  gap: 4px;
}
.lm-admin-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.lm-admin-pagination__btn:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.lm-admin-pagination__btn--active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
.lm-admin-pagination__btn--active:hover {
  background: #606164;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/admin-learner-maps-list/admin-learner-maps-list.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAzYA;EACE,uBAAA;EACA,iBAAA;AA4YF;AA1YE;EAJF;IAKI,uBAAA;EA6YF;AACF;AA3YE;EARF;IASI,uBAAA;EA8YF;AACF;;AAvYA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA0YF;AAxYE;EAPF;IAQI,sBAAA;IACA,uBAAA;IACA,mBAAA;EA2YF;AACF;AAzYE;EACE,OAAA;AA2YJ;AAxYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA0YJ;AAvYE;EACE,eAAA;EACA,gBAAA;EACA,cDRiB;ECSjB,SAAA;EACA,uBAAA;EACA,wEDnDS;ECoDT,gBAAA;AAyYJ;AAvYI;EATF;IAUI,eAAA;EA0YJ;AACF;AAvYE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,+DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDtES;ECuET,sBAAA;AAyYJ;AAvYI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AAyYN;;AAhYA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WDpDkB;ACubpB;AAjYE;EACE,aAAA;EACA,mBAAA;AAmYJ;AAjYI;EACE,YAAA;EACA,aAAA;EACA,WD7Dc;EC8Dd,eAAA;AAmYN;AAhYI;EACE,cDzEe;EC0Ef,qBAAA;EACA,4BAAA;AAkYN;AAhYM;EACE,wBD1FQ;AC4dhB;AA9XI;EACE,cD9Ee;EC+Ef,gBAAA;AAgYN;;AAvXA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBD5FoB;EC6FpB,kBAAA;EACA,yBAAA;AA0XF;AAxXE;EAXF;IAYI,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,kBAAA;EA2XF;AACF;AAzXE;EACE,OAAA;EACA,gBAAA;AA2XJ;AAzXI;EAJF;IAKI,eAAA;EA4XJ;AACF;AAzXE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA2XJ;AAzXI;EANF;IAOI,2BAAA;EA4XJ;AACF;;AApXA;EACE,kBAAA;EACA,WAAA;AAuXF;AArXE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WD1IgB;EC2IhB,eAAA;EACA,oBAAA;AAuXJ;AApXE;EACE,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wED/LS;ECgMT,cD7JiB;EC8JjB,gBAAA;EACA,wDAAA;EACA,aAAA;AAsXJ;AApXI;EACE,WD5Jc;ACkhBpB;AAnXI;EACE,+BDnLU;ECoLV,6CAAA;AAqXN;AAjXE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBD1KgB;EC2KhB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,iCAAA;AAmXJ;AAjXI;EACE,mBDhMe;ACmjBrB;;AA1WA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDrPW;ECsPX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AA6WF;AA3WE;EACE,6BDtOY;ECuOZ,WAAA;EACA,+BDxOY;ACqlBhB;AA3WI;EACE,mBDrNa;ECsNb,qBDtNa;ACmkBnB;AAzWE;EACE,gBAAA;EACA,cDtOiB;ECuOjB,qBDzNW;ACokBf;AAzWI;EACE,mBDlOgB;ECmOhB,kBDpOc;AC+kBpB;;AAlWA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AAqWF;;AA9VA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAiWF;AA/VE;EACE,eAAA;EACA,mBAAA;EACA,WDpQgB;ACqmBpB;AA9VE;EACE,eAAA;EACA,cDhRiB;ECiRjB,SAAA;AAgWJ;AA7VE;EACE,kBAAA;AA+VJ;;AAvVA;EACE,gBAAA;AA0VF;;AAvVA;EACE,WAAA;EACA,yBAAA;EACA,SAAA;AA0VF;AAvVI;EACE,mBDhSgB;ACynBtB;AAtVI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD5Se;EC6Sf,gCAAA;EACA,mBAAA;EACA,wEDvVO;ECwVP,gBAAA;AAwVN;AAtVM;EACE,gBAAA;EACA,eAAA;EACA,WDnTY;AC2oBpB;AAlVI;EACE,uCAAA;EACA,gCAAA;AAoVN;AAlVM;EACE,0CAAA;AAoVR;AAjVM;EACE,0CAAA;AAmVR;AAjVQ;EACE,0CAAA;AAmVV;AA/UM;EACE,kBAAA;EACA,eAAA;EACA,cDnVa;ECoVb,sBAAA;AAiVR;AA5UE;EACE,cD1ViB;EC2VjB,qBAAA;EACA,gBAAA;EACA,4BAAA;AA8UJ;AA5UI;EACE,wBD5WU;AC0rBhB;AA1UE;EACE,eAAA;AA4UJ;AAzUE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AA2UJ;AAzUI;EACE,uBDjYU;ECkYV,kCAAA;AA2UN;AAxUI;EACE,wBDpYU;ECqYV,mCAAA;AA0UN;AApUE;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AAsUJ;AApUI;EACE,wBDjZU;ACutBhB;AApUM;EACE,wBDpZQ;AC0tBhB;AAjUE;EACE,YAAA;EACA,gBAAA;AAmUJ;AAhUE;EACE,mBAAA;EACA,gBAAA;EACA,iCAAA;AAkUJ;AA/TE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AAiUJ;AA/TI;EACE,mCAAA;EACA,uBDtbU;ECubV,qCAAA;AAiUN;AA/TM;EACE,4BD1bQ;EC2bR,WAAA;AAiUR;AA7TI;EACE,oCAAA;EACA,wBD/bU;ECgcV,sCAAA;AA+TN;AA7TM;EACE,6BDncQ;ECocR,WAAA;AA+TR;AA3TI;EACE,qCAAA;EACA,cD9be;EC+bf,uCAAA;AA6TN;AA3TM;EACE,mBDlca;ECmcb,WAAA;AA6TR;AAzTI;EACE,UAAA;EACA,oBAAA;EACA,mCAAA;EACA,uBDtdY;ECudZ,qCAAA;EACA,uEAAA;AA2TN;AAzTM;EACE,4BD3dU;EC4dV,WAAA;AA2TR;AAvTI;EACE,oCAAA;EACA,wBDneU;ECoeV,sCAAA;AAyTN;AAvTM;EACE,6BDveQ;ECweR,WAAA;AAyTR;AArTI;EACE,mCAAA;EACA,uBD/eS;ECgfT,qCAAA;AAuTN;AArTM;EACE,4BDnfO;ECofP,WAAA;AAuTR;;AAhTA;EACE,UAAA;EACA,oBAAA;AAmTF;;AA5SA;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wEDhiBW;ECiiBX,cD9fmB;EC+fnB,gBAAA;EACA,kCAAA;AA+SF;AA7SE;EACE,+BD/gBY;ECghBZ,aAAA;EACA,6CAAA;AA+SJ;AA5SE;EACE,cAAA;EACA,eAAA;EACA,uBDthBc;ECuhBd,eAAA;EACA,gBAAA;AA8SJ;;AAtSA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;AAySF;AAvSE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAySJ;AAvSI;EACE,eAAA;EACA,gBAAA;EACA,cD/hBe;ECgiBf,SAAA;EACA,mBAAA;AAySN;AAtSI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cD/iBe;ECgjBf,gBAAA;EACA,wEDplBO;AC43Bb;AAtSM;EACE,+BDhkBQ;ECikBR,aAAA;AAwSR;AAnSE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAqSJ;AAlSE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD3kBiB;EC4kBjB,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,wEDlnBS;ACs5Bb;AAlSI;EACE,mBD1kBgB;EC2kBhB,kBD5kBc;ACg3BpB;AAjSI;EACE,mBDllBe;ECmlBf,WAAA;EACA,qBDplBe;ACu3BrB;AAjSM;EACE,mBAAA;AAmSR","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n// ─────────────────────────────────────────────\n// Page Layout\n// ─────────────────────────────────────────────\n\n.lm-admin-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) {\n    padding: 24px 28px 36px;\n  }\n\n  @media (max-width: 640px) {\n    padding: 16px 16px 28px;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Header\n// ─────────────────────────────────────────────\n\n.lm-admin-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  gap: 16px;\n\n  @media (max-width: 640px) {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 20px;\n  }\n\n  &__left {\n    flex: 1;\n  }\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    line-height: 1.2;\n\n    @media (max-width: 640px) {\n      font-size: 22px;\n    }\n  }\n\n  &__count {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    height: 28px;\n    padding: 0 12px;\n    border-radius: 14px;\n    background: linear-gradient(135deg, $develop-color, darken($develop-color, 8%));\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: $font-stack;\n    letter-spacing: 0.02em;\n\n    &-label {\n      font-size: 11px;\n      font-weight: 500;\n      opacity: 0.85;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Breadcrumb\n// ─────────────────────────────────────────────\n\n.lm-admin-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after {\n      content: '/';\n      margin: 0 8px;\n      color: $color-neutral-mid;\n      font-size: 11px;\n    }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n\n      &:hover {\n        color: $develop-color;\n      }\n    }\n\n    &.lm-admin-breadcrumb__current {\n      color: $color-neutral-dark;\n      font-weight: 600;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Toolbar\n// ─────────────────────────────────────────────\n\n.lm-admin-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 14px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n\n  &__left {\n    flex: 1;\n    max-width: 360px;\n\n    @media (max-width: 767px) {\n      max-width: none;\n    }\n  }\n\n  &__right {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    @media (max-width: 640px) {\n      justify-content: flex-start;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Search\n// ─────────────────────────────────────────────\n\n.lm-admin-search {\n  position: relative;\n  width: 100%;\n\n  &__icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: $color-neutral-mid;\n    font-size: 13px;\n    pointer-events: none;\n  }\n\n  &__input {\n    width: 100%;\n    padding: 9px 36px 9px 34px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: #fff;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    outline: none;\n\n    &::placeholder {\n      color: $color-neutral-mid;\n    }\n\n    &:focus {\n      border-color: $develop-color;\n      box-shadow: 0 0 0 3px rgba($develop-color, 0.1);\n    }\n  }\n\n  &__clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: $color-neutral-mid;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 10px;\n    padding: 0;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: $body-content-color;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Buttons\n// ─────────────────────────────────────────────\n\n.lm-admin-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n  line-height: 1.4;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n\n    &:hover {\n      background: $color-dark-green;\n      border-color: $color-dark-green;\n    }\n  }\n\n  &--secondary {\n    background: #fff;\n    color: $body-content-color;\n    border-color: $color-grey-1;\n\n    &:hover {\n      background: $color-neutral-light;\n      border-color: $color-neutral-mid;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Content Area\n// ─────────────────────────────────────────────\n\n.lm-admin-content {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n  overflow: visible;\n  min-height: 200px;\n}\n\n// ─────────────────────────────────────────────\n// States\n// ─────────────────────────────────────────────\n\n.lm-admin-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i {\n    font-size: 36px;\n    margin-bottom: 16px;\n    color: $color-neutral-mid;\n  }\n\n  p {\n    font-size: 15px;\n    color: $body-content-color;\n    margin: 0;\n  }\n\n  &--loading {\n    padding: 48px 20px;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Table\n// ─────────────────────────────────────────────\n\n.lm-admin-table-wrap {\n  overflow-x: auto;\n}\n\n.lm-admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0;\n\n  thead {\n    tr {\n      background: $color-neutral-light;\n    }\n\n    th {\n      padding: 12px 16px;\n      font-size: 11px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      color: $color-neutral-dark;\n      border-bottom: 2px solid $color-grey-1;\n      white-space: nowrap;\n      font-family: $font-stack;\n      text-align: left;\n\n      i.fa {\n        margin-left: 4px;\n        font-size: 12px;\n        color: $color-neutral-mid;\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      transition: background-color 0.12s ease;\n      border-bottom: 1px solid $color-grey-1;\n\n      &:hover {\n        background-color: rgba($develop-color, 0.03);\n      }\n\n      &:nth-of-type(even) {\n        background-color: rgba($color-neutral-light, 0.5);\n\n        &:hover {\n          background-color: rgba($develop-color, 0.03);\n        }\n      }\n\n      td {\n        padding: 12px 16px;\n        font-size: 13px;\n        color: $body-content-color;\n        vertical-align: middle;\n      }\n    }\n  }\n\n  &__link {\n    color: $body-content-color;\n    text-decoration: none;\n    font-weight: 600;\n    transition: color 0.15s ease;\n\n    &:hover {\n      color: $develop-color;\n    }\n  }\n\n  &__features {\n    margin-top: 4px;\n  }\n\n  &__feature-tag {\n    display: inline-block;\n    padding: 2px 8px;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    border-radius: 3px;\n    margin-right: 4px;\n\n    &--staging {\n      color: $clarify-color;\n      background: rgba($clarify-color, 0.1);\n    }\n\n    &--prod {\n      color: $develop-color;\n      background: rgba($develop-color, 0.1);\n    }\n  }\n\n  // ── Actions ──\n\n  &__sortable {\n    cursor: pointer;\n    user-select: none;\n    transition: color 0.15s ease;\n\n    &:hover {\n      color: $develop-color;\n\n      i.fa {\n        color: $develop-color;\n      }\n    }\n  }\n\n  &__actions-col {\n    width: 140px;\n    text-align: left;\n  }\n\n  &__actions {\n    white-space: nowrap;\n    text-align: left;\n    vertical-align: middle !important;\n  }\n\n  &__action {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    margin: 0 2px;\n    border-radius: 5px;\n    font-size: 12px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &--edit {\n      background: rgba($clarify-color, 0.08);\n      color: $clarify-color;\n      border-color: rgba($clarify-color, 0.15);\n\n      &:hover {\n        background: $clarify-color;\n        color: #fff;\n      }\n    }\n\n    &--clone {\n      background: rgba($develop-color, 0.08);\n      color: $develop-color;\n      border-color: rgba($develop-color, 0.15);\n\n      &:hover {\n        background: $develop-color;\n        color: #fff;\n      }\n    }\n\n    &--view {\n      background: rgba($body-content-color, 0.06);\n      color: $body-content-color;\n      border-color: rgba($body-content-color, 0.12);\n\n      &:hover {\n        background: $body-content-color;\n        color: #fff;\n      }\n    }\n\n    &--delete {\n      opacity: 0;\n      pointer-events: none;\n      background: rgba($implement-color, 0.08);\n      color: $implement-color;\n      border-color: rgba($implement-color, 0.15);\n      transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;\n\n      &:hover {\n        background: $implement-color;\n        color: #fff;\n      }\n    }\n\n    &--save {\n      background: rgba($develop-color, 0.08);\n      color: $develop-color;\n      border-color: rgba($develop-color, 0.15);\n\n      &:hover {\n        background: $develop-color;\n        color: #fff;\n      }\n    }\n\n    &--cancel {\n      background: rgba($ideate-color, 0.08);\n      color: $ideate-color;\n      border-color: rgba($ideate-color, 0.15);\n\n      &:hover {\n        background: $ideate-color;\n        color: #fff;\n      }\n    }\n  }\n}\n\n// Show delete on row hover\n.lm-admin-table tbody tr:hover .lm-admin-table__action--delete {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n// ─────────────────────────────────────────────\n// Inline Edit Inputs\n// ─────────────────────────────────────────────\n\n.lm-admin-input {\n  width: 100%;\n  padding: 6px 10px;\n  font-size: 13px;\n  border: 1px solid $color-grey-1;\n  border-radius: 4px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  background: #fff;\n  transition: border-color 0.2s ease;\n\n  &:focus {\n    border-color: $develop-color;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba($develop-color, 0.1);\n  }\n\n  &__error {\n    display: block;\n    font-size: 11px;\n    color: $implement-color;\n    margin-top: 3px;\n    font-weight: 600;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Pagination\n// ─────────────────────────────────────────────\n\n.lm-admin-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-top: 1px solid $color-grey-1;\n\n  &__perpage {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    label {\n      font-size: 12px;\n      font-weight: 600;\n      color: $color-neutral-dark;\n      margin: 0;\n      white-space: nowrap;\n    }\n\n    select {\n      width: 70px;\n      padding: 4px 8px;\n      font-size: 13px;\n      border: 1px solid $color-grey-1;\n      border-radius: 4px;\n      color: $body-content-color;\n      background: #fff;\n      font-family: $font-stack;\n\n      &:focus {\n        border-color: $develop-color;\n        outline: none;\n      }\n    }\n  }\n\n  &__pages {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 32px;\n    height: 32px;\n    padding: 0 8px;\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 500;\n    color: $body-content-color;\n    background: #fff;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-family: $font-stack;\n\n    &:hover {\n      background: $color-neutral-light;\n      border-color: $color-neutral-mid;\n    }\n\n    &--active {\n      background: $color-neutral-dark;\n      color: #fff;\n      border-color: $color-neutral-dark;\n\n      &:hover {\n        background: darken($color-neutral-dark, 5%);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
